interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

export default function Loading({
  message = "Carregando...",
  fullScreen = true,
}: LoadingProps) {
  const content = (
    <div className="flex flex-col items-center justify-center text-center space-y-4 py-12">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-mygreen/20 rounded-full" />
        <div className="absolute inset-0 border-4 border-mygreen border-t-transparent rounded-full animate-spin" />
      </div>
      <p className="text-gray-600 text-sm font-medium">{message}</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-50">
        {content}
      </div>
    );
  }

  return content;
}
